export default {
      id: "zirve_oran-usage",
      viewBox: "0 0 38 38",
      url: "/" + "images/icons.3.109.2.svg#zirve_oran-usage",
      toString: function () {
        return this.url;
      }
    }